var chopstickBlazy = function () {
    var item = $('.js-blazy');

    var bLazy = new Blazy({
        selector: ".js-blazy",
        successClass: "p-blazy--loaded",
        // breakpoints: [{
        //     width: 320, // max-width
        //     src: 'data-src-small'
        // }, {
        //     width: 768, // max-width
        //     src: 'data-src-medium'
        // }],
        succes: function(element) {
            console.log(element);
        },
        error: function(element, msg) {
            if (msg === 'missing') {
                console.log('img missing')
            } else {
                console.log(msg);
            }
        }
    });

};
